import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/digitala-tjanster";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/digital-services")(
  enRouteOptions(routeOptions, {
    svPath: "/digitala-tjanster",
    title: 'Digital Services for Restaurants and Bars 2026',
    description: 'Google Business Profile, websites, social media and compliance documentation for Swedish restaurants and bars. Packages from SEK 2,900.',
    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
